import React from 'react';
import { trackCustomEvent } from '../../utils/statistics/clientStatistics';
import { languageSupportClick } from '../../utils/statistics/customEvents';
import { A11yLinksList, A11yListItem, A11yLink, A11yIcon } from './AccessibilityLinks.styles';
import PropTypes from 'prop-types';
import { SVG_ICONS } from '../SvgIcon/SvgIcon';

const AccessibilityLinks = ({ isVisible }) => {
    if (!isVisible) {
        return null;
    }

    const trackA11yLinkClick = (type) => {
        trackCustomEvent(languageSupportClick(type));
    };

    return (
        <A11yLinksList>
            <A11yListItem data-rt="a11y-audio-description">
                <A11yLink to="/syntolkat" onAfterClick={(e) => trackA11yLinkClick('syntolkat')}>
                    <A11yIcon aria-hidden="true" icon={SVG_ICONS.SIGHT} width={18} />
                    Syntolkat
                </A11yLink>
            </A11yListItem>
            <A11yListItem data-rt="a11y-sign-language">
                <A11yLink to="/teckensprak" onAfterClick={(e) => trackA11yLinkClick('teckenspråk')}>
                    <A11yIcon aria-hidden="true" icon={SVG_ICONS.SIGN_LANGUAGE} width={18} />
                    Teckenspråk
                </A11yLink>
            </A11yListItem>
        </A11yLinksList>
    );
};

AccessibilityLinks.propTypes = {
    isVisible: PropTypes.bool,
};

export default AccessibilityLinks;
